import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { isFuture } from 'date-fns/isFuture';
import LanguageContext from '@lib/contexts/languageContext';
import { PromotionBanner } from './PromotionBanner';

const ENABLED_PATHS = [
  { path: '/[lang]', exact: true },
  { path: '/[lang]/challenges', exact: true },
  { path: '/[lang]/programs', exact: true },
  { path: '/[lang]/marketplace', exact: true },
  { path: '/[lang]/blog', exact: false },
  { path: '/[lang]/friskvardsbidrag', exact: false },
];

export const end_date = new Date(Date.UTC(2025, 7, 4, 22));

export const SummerChallengeBanner = () => {
  const router = useRouter();
  const lang = useContext(LanguageContext);

  const allowed_on_page = ENABLED_PATHS.some((item) => {
    if (item.exact) {
      return item.path === router.pathname;
    } else {
      return router.pathname.startsWith(item.path);
    }
  });

  const show = isFuture(end_date);
  if (!(show && allowed_on_page && ['se', 'no'].includes(lang))) {
    return null;
  }

  const link = `/se/challenges/summer-yoga-challenge-2025/overview`,
    message =
      '30 dagar sommaryoga – anmäl dig till utmaningen. Klicka här! 🍓 ';

  return (
    <PromotionBanner appearance="main">
      <Link
        href={link}
        style={{ color: 'inherit' }}
        target="_blank"
        rel="noreferrer"
      >
        {message}
      </Link>
    </PromotionBanner>
  );
};
